'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resolveUsedProps;

var _objectReduce = require('fast-loops/lib/objectReduce');

var _objectReduce2 = _interopRequireDefault(_objectReduce);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function resolveUsedProps(props, src) {
  return (0, _objectReduce2.default)(src, function (output, value, prop) {
    if (props.indexOf(prop) === -1 && prop !== 'innerRef' && prop !== 'is') {
      output.push(prop);
    }

    return output;
  }, []);
}